import UISearchInput from 'UIComponents/input/UISearchInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PatagoniaSearchBarContainer = ({
  sidebarSearchQuery,
  handleSearchInput,
  isDisabled
}) => {
  const handleOnChange = useCallback(e => {
    handleSearchInput(e.target.value);
  }, [handleSearchInput]);
  return /*#__PURE__*/_jsx(FormControl, {
    padding: "300",
    "aria-label": "Search",
    children: /*#__PURE__*/_jsx(UISearchInput, {
      use: "on-dark",
      value: isDisabled ? '' : sidebarSearchQuery,
      placeholder: "",
      onChange: handleOnChange,
      disabled: isDisabled
    })
  });
};
export default PatagoniaSearchBarContainer;